import { UserFileType } from './types';

import { UserFileActionType } from 'enums';
import { UserFileActionReturnType } from 'state/actions';

const initState: UserFileType = {
  inspectionFileId: '',
};

export const userFileReducer = (
  // eslint-disable-next-line default-param-last
  state: UserFileType = initState,
  action: UserFileActionReturnType,
): UserFileType => {
  switch (action.type) {
    case UserFileActionType.SET_USER_FILE:
      return { ...state, ...action.userFile };
    case UserFileActionType.UPDATE_USER_FILE:
      return {
        ...state,
        ...action.userFile,
      };
    default:
      return state;
  }
};
